import React from 'react'
import { useReactiveVar } from '@apollo/client'
import { countryCodeVar, labelCodeIdVar } from 'modulesCommon/store'
import { FollowedProjects } from 'modulesCommon/Notifications/components'
import { useFollowedProjects, useNotifications } from '../services'

const FollowedProjectsContainer = () => {
  const country = useReactiveVar(countryCodeVar)
  const zoneId = useReactiveVar(labelCodeIdVar)
  const { getNotificationsByType } = useNotifications()
  const { followedProjects } = useFollowedProjects(zoneId, country, getNotificationsByType('UnreadArgument'))

  return <FollowedProjects projects={followedProjects} />
}

export default FollowedProjectsContainer
